export default __webpack_public_path__ + "static/media/connectus-on-black.4e61a891.png";